import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Image, Text } from 'Components/Base';

const IncompatibleMyPathWithMobile = (props) => {
  const { t } = useTranslation('myPath');

  return (
    <Flex
      gridRowGap={2}
      flexDirection={'column'}
      backgroundColor={'white'}
      padding={2}
      style={{ borderRadius: 8 }}
      {...props}
    >
      <Flex gridColumnGap={1} alignItems={'center'}>
        <Image src={'/assets/images/myPath/myPathLogo.svg'} />
        <Text textStyle={'body1'} fontWeight={'bold'}>
          {t('INCOMPATIBLE.TITLE')}
        </Text>
      </Flex>
      <Text textAlign={'center'} textStyle={'body2'} fontWeight={500} color={'danger'}>
        {t('INCOMPATIBLE.DESCRIPTION')}
      </Text>
    </Flex>
  );
};

export default IncompatibleMyPathWithMobile;
